import { InfoIcon, ErrorIcon, WarningIcon, DoneIcon } from '../../icons/index.js';
import { jsx } from 'react/jsx-runtime';

const MuiAlertOverrides = {
  MuiAlert: {
    styleOverrides: {
      root: _ref => {
        let {
          theme
        } = _ref;
        return {
          ...theme.typography.body01,
          color: theme.palette.text.primary,
          '.MuiAlert-icon': {
            color: theme.palette.text.primary
          },
          '&.MuiAlert-outlinedInfo .MuiAlert-icon, &.MuiAlert-outlinedSuccess .MuiAlert-icon, &.MuiAlert-outlinedError .MuiAlert-icon': {
            color: theme.palette.white
          },
          '.MuiIconButton-root': {
            position: 'absolute',
            right: theme.spacing(0.5),
            top: theme.spacing(0.3)
          },
          '&.MuiAlert-outlinedInfo': {
            '--alertColor': theme.palette.gray70
          },
          '&.MuiAlert-outlinedSuccess': {
            '--alertColor': theme.palette.blueBase,
            '--alertBorderColor': theme.palette.blueBase
          },
          '&.MuiAlert-outlinedWarning': {
            '--alertColor': theme.palette.yellow.main,
            '--alertBorderColor': theme.palette.yellow.main
          },
          '&.MuiAlert-outlinedError': {
            '--alertColor': theme.palette.redBase,
            '--alertBorderColor': theme.palette.redBase
          }
        };
      },
      action: () => ({
        alignItems: 'center'
      }),
      standardInfo: _ref2 => {
        let {
          theme
        } = _ref2;
        return {
          backgroundColor: theme.palette.info.light
        };
      },
      standardSuccess: _ref3 => {
        let {
          theme
        } = _ref3;
        return {
          backgroundColor: theme.palette.success.light
        };
      },
      standardWarning: _ref4 => {
        let {
          theme
        } = _ref4;
        return {
          backgroundColor: theme.palette.warning.light
        };
      },
      standardError: _ref5 => {
        let {
          theme
        } = _ref5;
        return {
          backgroundColor: theme.palette.error.light
        };
      },
      outlined: _ref6 => {
        let {
          theme
        } = _ref6;
        return {
          paddingLeft: 0,
          paddingTop: 0,
          paddingBottom: 0,
          position: 'relative',
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: `var(--alertBorderColor, ${theme.palette.gray40})`
        };
      },
      icon: _ref7 => {
        let {
          theme
        } = _ref7;
        return {
          opacity: 1,
          variants: [{
            props: {
              variant: 'outlined'
            },
            style: {
              paddingLeft: theme.spacing(1.75),
              paddingRight: theme.spacing(1.75),
              paddingTop: theme.spacing(1.2),
              paddingBottom: theme.spacing(1.2),
              borderRight: '1px solid var(--alertColor)',
              backgroundColor: 'var(--alertColor)',
              border: `1px solid var(--alertColor, ${theme.palette.gray40})`,
              marginLeft: -1,
              marginTop: -1,
              marginBottom: -1
            }
          }]
        };
      },
      message: _ref8 => {
        let {
          theme
        } = _ref8;
        return {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: theme.spacing(1),
          paddingLeft: theme.spacing(1),
          paddingRight: theme.spacing(1)
        };
      }
    },
    defaultProps: {
      iconMapping: {
        success: /*#__PURE__*/jsx(DoneIcon, {}),
        warning: /*#__PURE__*/jsx(WarningIcon, {}),
        error: /*#__PURE__*/jsx(ErrorIcon, {}),
        info: /*#__PURE__*/jsx(InfoIcon, {}),
        muted: /*#__PURE__*/jsx(InfoIcon, {})
      }
    }
  },
  MuiAlertTitle: {
    defaultProps: {},
    styleOverrides: {
      root: _ref9 => {
        let {
          theme
        } = _ref9;
        return {
          ...theme.typography.body02,
          '.MuiAlert-outlined &': {
            margin: 0
          }
        };
      }
    }
  }
};

export { MuiAlertOverrides };
